<div class="list-page kapea" style="max-width: 1200px">
  @if (kirjanpitajaOnDevaajaObservable | async) {
    <div style="padding: 10px; margin-bottom: 20px; margin-left: 20px; max-width: 600px; position: relative" class="mat-elevation-z2">
      <span style="font-size: 10px; position: absolute; top: 3px; right: 5px" class="light-gray-text">(Vain devaajat)</span>
      <h3 style="margin: 0">Urit</h3>
      <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
        Lähetykset: <a [href]="lahetyksetEncodedUriObservable | async" target="_BLANK">{{ lahetyksetUriObservable | async }}</a>
      </div>
    </div>
  }

  <h2>Asiakkaalle lähetetyt kirjanpito sähköpostit</h2>

  <div style="padding-left: 3em; padding-right: 3em">
    @if (naytettavatLahetyksetObservable | async; as naytettavatLahetykset) {
      @if (naytettavatLahetykset.length) {
        <table>
          <thead>
            <td>Aihe</td>
            <td>Kuukausi</td>
            <td>Luotu Lemonatorissa</td>
            <td>Lähetetty Postmarkista</td>
            <td>Luoja</td>
            <td>Saaja(t)</td>
          </thead>
          @for (lahetys of naytettavatLahetykset; track lahetys) {
            <tr class="bordered-row">
              <td>{{ lahetys.aihe }}</td>
              <td>{{ lahetys.kuukausi }}</td>
              <td>{{ lahetys.luotu }}</td>
              <td>{{ lahetys.lahetetty }}</td>
              <td>{{ lahetys.luojaNimi }}</td>
              <td>{{ lahetys.recipients }}</td>
            </tr>
          }
        </table>
      } @else {
        <div class="no-emails-text">Sähköposteja ei ole vielä lähetetty</div>
      }
    } @else {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </div>
</div>
